var o=function(r){return r.ESCORT="escort",r.HOSTESS="hostess",r}({});export{o as AttendantType};